import { FETCH_ME, SET_TOP_MENU } from '../constants/ActionTypes';
import axios from 'axios';
import qs from 'qs';
import moment from 'moment';

export default function fetchMe(type,ids) {
  return (dispatch, getState)=> {
    const promise=axios.get(`/api/user/me`);
    promise.then((data)=>{
      let topMenu=[];
      if(data.data.answer) {
        topMenu=[
          { name:'Home', route:'/' },
          { name:'Chat', route:'/chat/', regexp:'^/chat.*$' },
          { name:'Blog', route:'/blog/my/', regexp:'^/blog.*$' },
          { name:'Photos', route:'/photospot/my/', regexp:'^/photospot.*$' },
          { name:'Figures', route:'/figures/my/', regexp:'^/figures.*$'},
          { name:'Anime', route:'/anime/my/', regexp:'^/anime.*$' },
          { name:'Characters', route:'/characters/', regexp:'^/characters.*$' },
          { name:'Users', route:'/shelf/', regexp:'^/shelf.*$' },
          { name:'Market', route:'/market/', regexp:'^/market.*$'},
        ];
      } else {
        topMenu=[
          { name:'Home', route:'/' },
          { name:'Blog', route:'/blog/', regexp:'^/blog.*$' },
          { name:'Photos', route:'/photospot/', regexp:'^/photospot.*$' },
          { name:'Figures', route:'/figures/', regexp:'^/figures.*$' },
          { name:'Anime', route:'/anime/', regexp:'^/anime.*$' },
          { name:'Characters', route:'/characters/', regexp:'^/characters.*$' },
          { name:'Users', route:'/shelf/', regexp:'^/shelf.*$' },
          { name:'Market', route:'/market/', regexp:'^/market.*$' },
        ];
      }

      dispatch({
        type: SET_TOP_MENU,
        value: topMenu
      });

    });

    return dispatch({
      type: FETCH_ME,
      payload: promise
    });
  }
}

